import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ActivityBar from "./components/ActivityBar";
import Sidebar from "./components/Sidebar";
import TabBar from "./components/TabBar";
import StatusBar from "./components/StatusBar";
import TerminalPanel from "./components/TerminalPanel";
import HomePage from "./pages/HomePage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import AboutPage from "./pages/AboutPage";
import NotFoundPage from "./pages/NotFoundPage";
import "./App.css";

function App() {
  const location = useLocation();
  const [terminalOpen, setTerminalOpen] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="vsc-shell">
      {/* Title bar */}
      <div className="vsc-titlebar">
        {/* <div className="vsc-titlebar__dots">
          <span className="dot dot--red" />
          <span className="dot dot--yellow" />
          <span className="dot dot--green" />
        </div> */}
        <span className="vsc-titlebar__title">Tommy BOUBAKER</span>
        {/* <div className="vsc-titlebar__spacer" /> */}
      </div>

      {/* Main row: activity bar + sidebar + editor */}
      <div className="vsc-main">
        <ActivityBar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          terminalOpen={terminalOpen}
          setTerminalOpen={setTerminalOpen}
        />

        {sidebarOpen && <Sidebar />}

        <div className="vsc-editor-area">
          <TabBar />

          <div className="vsc-editor-body">
            <div className="vsc-editor-content">
              <div className="vsc-editor-scroll">
                <LineNumbers />
                <main
                  className="vsc-editor-inner page-enter"
                  key={location.pathname}
                >
                  <Routes>
                    <Route path="/portfolio/" element={<HomePage />} />
                    <Route path="/portfolio/projects" element={<ProjectsPage />} />
                    <Route
                      path="/portfolio/projects/:id"
                      element={<ProjectDetailPage />}
                    />
                    <Route path="/portfolio/about" element={<AboutPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                  </Routes>
                </main>
              </div>
            </div>

            {/* {terminalOpen && (
              <TerminalPanel onClose={() => setTerminalOpen(false)} />
            )} */}
          </div>
        </div>
      </div>

      <StatusBar
        terminalOpen={terminalOpen}
        setTerminalOpen={setTerminalOpen}
      />
    </div>
  );
}

function LineNumbers() {
  const lines = Array.from({ length: 80 }, (_, i) => i + 1);
  return (
    <div className="vsc-gutter" aria-hidden="true">
      {lines.map((n) => (
        <span key={n} className="vsc-gutter__line">
          {n}
        </span>
      ))}
    </div>
  );
}

export default App;
